import React, { useState } from 'react';
import {
  Modal, BlockStack, InlineStack, Text, Collapsible, ResourceList, ResourceItem, useBreakpoints,
} from '@shopify/polaris';

export default function DiffModal({ resp, onCommit, onCancel, busy }) {
  const [openAdd, setOpenAdd] = useState(false);
  const [openRem, setOpenRem] = useState(false);
  const [openChg, setOpenChg] = useState(true);
  const [openShift, setOpenShift] = useState(true);
  const shifts = resp.diff.window_shifts || [];
  const { mdUp } = useBreakpoints();

  return (
    <Modal
      open
      onClose={onCancel}
      title="Confirm upload"
      primaryAction={{ content: 'Commit', onAction: onCommit, loading: busy }}
      secondaryActions={[{ content: 'Cancel', onAction: onCancel, disabled: busy }]}
      size={mdUp ? 'large' : 'small'}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <InlineStack gap="800" wrap={false}>
            <Text as="p" variant="headingSm">Season: {resp.parse_summary.season}</Text>
            <Text as="p" variant="headingSm">SKUs: {resp.parse_summary.sku_count}</Text>
            <Text as="p" variant="headingSm">Pricing rows: {resp.parse_summary.rows_pricing}</Text>
            <Text as="p" variant="headingSm">UPCs: {resp.parse_summary.rows_upcs}</Text>
          </InlineStack>

          <details open={openAdd} onToggle={(e) => setOpenAdd(e.target.open)}>
            <summary><Text as="span" variant="headingSm">Added SKUs ({resp.diff.added.length})</Text></summary>
            <Collapsible open={openAdd} id="add">
              <ResourceList
                items={resp.diff.added}
                renderItem={(it) => (
                  <ResourceItem id={`${it.article}|${it.color}`} accessibilityLabel={it.description} onClick={() => {}}>
                    <Text as="p">{it.description} — {it.article} ({it.color})</Text>
                  </ResourceItem>
                )}
              />
            </Collapsible>
          </details>

          <details open={openRem} onToggle={(e) => setOpenRem(e.target.open)}>
            <summary><Text as="span" variant="headingSm">Removed SKUs ({resp.diff.removed.length}) — flagged “Removed from MAP” or dropped from the file</Text></summary>
            <Collapsible open={openRem} id="rem">
              <ResourceList
                items={resp.diff.removed}
                renderItem={(it) => (
                  <ResourceItem id={`${it.article}|${it.color}`} accessibilityLabel={it.description} onClick={() => {}}>
                    <Text as="p">{it.description} — {it.article} ({it.color}){it.how ? ` · ${it.how === 'flagged' ? 'flagged Removed from MAP' : 'dropped from the file, no flag'}` : ''}</Text>
                  </ResourceItem>
                )}
              />
            </Collapsible>
          </details>

          <details open={openShift} onToggle={(e) => setOpenShift(e.target.open)}>
            <summary><Text as="span" variant="headingSm">Window date changes ({shifts.length}) — same window, new start or end</Text></summary>
            <Collapsible open={openShift} id="shift">
              <ResourceList
                items={shifts}
                renderItem={(s) => (
                  <ResourceItem id={`${s.article}|${s.color}|${s.window_name}`} accessibilityLabel={s.window_name} onClick={() => {}}>
                    <Text as="p">
                      {s.article} ({s.color}) — {s.window_name}: {s.old_start} → {s.old_end} becomes {s.new_start} → {s.new_end}
                    </Text>
                  </ResourceItem>
                )}
              />
            </Collapsible>
          </details>

          <details open={openChg} onToggle={(e) => setOpenChg(e.target.open)}>
            <summary><Text as="span" variant="headingSm">Price changes ({resp.diff.price_changed.length})</Text></summary>
            <Collapsible open={openChg} id="chg">
              <ResourceList
                items={resp.diff.price_changed}
                renderItem={(c) => (
                  <ResourceItem
                    id={`${c.article}|${c.color}|${c.window_name}|${c.start_date}`}
                    accessibilityLabel={c.window_name}
                    onClick={() => {}}
                  >
                    <Text as="p">
                      {c.article} ({c.color}) — {c.window_name} on {c.start_date}:{' '}
                      ${c.old_price?.toFixed(2) ?? '—'} → ${c.new_price?.toFixed(2) ?? '—'}
                    </Text>
                  </ResourceItem>
                )}
              />
            </Collapsible>
          </details>
        </BlockStack>
      </Modal.Section>
    </Modal>
  );
}
